module.exports = __webpack_public_path__ + "static/conference-2026-1280-362aefe0e6f939cc39cf54509dea7c3a.webp";